import { enumUtil } from "./Enum"
import isNull from "./NullChecking"
import { isAfter, parse, format, isBefore } from 'date-fns';

const DateValidator = (startDate, endDate, type) => {
    if (type === enumUtil.enumValidationType.StartEndDate) {
        if (!isNull(endDate)) {
            if (isNull(startDate)) {
                return (
                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                          <i className="bi bi-info-circle-fill fs-10"></i>
                          <p className="fs-9 text-white text">Start Date Is Required!</p>
                    </div>
                )
            }
        }
         if(!isNull(startDate)) {
            const parsedStartDate = parse(startDate, 'MM/dd/yyyy', new Date());
            const parsedEndDate = parse(endDate, 'MM/dd/yyyy', new Date());
            if (isBefore(parsedEndDate, parsedStartDate)) {
                return (
                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1 GreaterDate" style={{ display: "block" }}>
                             <i className="bi bi-info-circle-fill fs-10"></i>
                             <p className="fs-9 text-white text">Start Date cannot be greater than ens date</p>
                        </div>
                )
            }
        }
        return '';
    }

}

export default DateValidator